module.exports = __webpack_public_path__ + "images/icons/icon-close-6058ad83.svg";